import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Button,
  Checkbox
} from '@chakra-ui/react';
import { CreateMailingListsApi } from '../../../../apis/CreateMaintenance.api';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { MailingListType } from '../Table/MaintenanceMailingListTable';
import { AxiosError } from 'axios';

interface props {
  isOpen: boolean;
  onClose: () => void;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<MailingListType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetMailInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const MailingListCreateWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, setMaintenanceDatas, CreateOrUpdateStateSwitch } =
    props;
  const [email, setEmail] = useState<string | undefined>('');
  const [enable, setEnable] = useState(false);

  const CreateApi = async () => {
    const response = await CreateMailingListsApi({
      email: email,
      enable: enable
    });
    if (
      response.message !== null &&
      (response.message as AxiosError).status?.toString() === '400'
    ) {
      alert('不正なメールアドレスの形式です。');
      return;
    } else if (response.success === false) {
      alert('登録に失敗しました。');
      return;
    }
    setMaintenanceDatas(response.data as MailingListType[]);
    CreateOrUpdateStateSwitch();
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='260px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            メーリングリスト作成
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>メールアドレス</Text>

              <CustomStringInput
                CheckInfo={GetMailInputCheckData('')}
                inputValue={email}
                setValue={setEmail}
                PhohibitionCharaCheck={false}
              />
              <Checkbox
                mt={4}
                gridColumn='2/2'
                onChange={(e) => setEnable(e.target.checked)}
              >
                有効
              </Checkbox>
            </Box>
            <Button mt={10} onClick={() => CreateApi()}>
              作成
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(MailingListCreateWindow);
